import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    OnDestroy,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { Subscription } from "rxjs";

import * as _moment from "moment";
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from "moment";

const moment = _rollupMoment || _moment;

@Component({
    selector: "app-dialog-contratistas",
    templateUrl: "./dialog-contratistas.component.html",
    styleUrls: ["./dialog-contratistas.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogContratistasComponent implements OnInit, OnDestroy {
    subscripciones: Subscription;
    constructor(
        public dialogRef: MatDialogRef<DialogContratistasComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            idServicioSolicitudCotizacion: number;
            idComuna: number;
            idRegion: number;
        }
    ) {
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {}

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
